export default __webpack_public_path__ + "static/media/logo.bf16f4c4.png";